import { GridColDef } from "@mui/x-data-grid";
import { useTranslate } from "@refinedev/core";

import { DataGrid } from "@shared/components/DataGrid";
import { TableCell } from "@shared/components";
import { usePaginatedTable } from "@shared/hooks";
import { PartnerAuditLog } from "@modules/partners/types";

export function AuditLogTab() {
  const translate = useTranslate();

  const { rows, loading, ...tableProps } = usePaginatedTable<PartnerAuditLog>({
    resource: "v1/partner_audit_log_admin",
    sorters: { ordering: "-id" },
  });

  const columns: GridColDef[] = [
    {
      field: "actor",
      headerName: translate("v1/partner_audit_log_admin.fields.actor"),
      minWidth: 160,
      renderCell: ({ value }) => <TableCell.Text value={value} textAlign="left" />,
    },
    {
      field: "action",
      headerName: translate("v1/partner_audit_log_admin.fields.action"),
      minWidth: 140,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "object_type",
      headerName: translate("v1/partner_audit_log_admin.fields.object_type"),
      minWidth: 140,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "object_id",
      headerName: translate("v1/partner_audit_log_admin.fields.object_id"),
      minWidth: 120,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "changes",
      headerName: translate("v1/partner_audit_log_admin.fields.changes"),
      minWidth: 260,
      renderCell: ({ row }) => (
        <TableCell.Text value={row.changes ? JSON.stringify(row.changes) : ""} />
      ),
    },
    {
      field: "created_at",
      headerName: translate("v1/partner_audit_log_admin.fields.created_at"),
      minWidth: 160,
      renderCell: ({ value }) => <TableCell.Date value={value} />,
    },
  ];

  return <DataGrid {...tableProps} rows={rows} columns={columns} loading={loading} />;
}
